import config from 'app/config/config'
import { client } from 'app/shared/api/client'
import { Dispatch } from 'redux'
import { getCompanies } from './actions'
import { coalesceThunk } from 'app/state/utils/coalesce-thunk'

export const loadAllCompanies = coalesceThunk(
  () => async (dispatch: Dispatch) => {
    const apiServerUrl = config.backendUrl
    return client
      .get(`${apiServerUrl}/api/companies`)
      .then(companies => {
        return dispatch(getCompanies(companies.data))
      })
      .catch(e => {
        return { success: false, payload: e.response.data.error }
      })
  },
)
